<template>
  <v-card>
    <v-card-title>
      Device Panic
      (List the most recent {{ items.length }} measurements. Latest record at the top)
      <v-btn small icon @click="dataRefresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search">
      </v-text-field>
    </v-card-title>
    <v-progress-linear
      :indeterminate="true"
      :active="showProgress">
    </v-progress-linear>
    <v-data-table
      v-bind:headers="headers"
      v-bind:items="items"
      v-bind:search="search"
      v-bind:rows-per-page-items="rowsPerPage"
      :disable-initial-sort="true">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.pressDuration }}</td>
        <td class="text-xs-left">{{ unixtimeAt(props.item.deviceTimestamp) }}</td>
        <td class="text-xs-left">{{ localAt(props.item.createdAt) }}</td>
      </template>
      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        From {{ pageStart }} to {{ pageStop }}
      </template>
    </v-data-table>
    <div class="red white--text subheading">{{ errMsg }}</div>
  </v-card>
</template>

<script>
  import mixins from '@/mixins.js'
  import DevicePanicService from '@/services/DevicePanicService'
  import moment from 'moment'

  export default {
    data() {
      return {
        errMsg: '',
        showProgress: true,
        tmp: '',
        search: '',
        selected: [],
        pagination: {},
        rowsPerPage: [
          10,
          20,
          {"text": "All", "value": -1}
        ],
        headers: [
          { text: 'Press Duration (millisecond)', align: 'left', value: 'pressDuration' },
          { text: 'Device Timestamp (local time)', align: 'left', value: 'deviceTimeStamp' },
          { text: 'Database Timestamp (local time)', align: 'left', value: 'createdAt' },
        ],
        items: []
      }
    },
    mixins: [mixins],
    async mounted() {
      try {
        this.errMsg = ''
        this.showProgress = true
        const deviceId = this.$route.params.deviceId
        this.items = (await DevicePanicService.show({deviceId})).data
        this.showProgress = false
      } catch (error) {
        this.showProgress = false
        this.errMsg = this.handleError(error)
      }
    },
    methods: {
      localAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      unixtimeAt: function(time) {
        return moment(time).format("YYYY-MM-DD HH:mm:ss.SSS A")
      },
      async dataRefresh() {
        try {
          this.errMsg = ''
          this.showProgress = true
          const deviceId = this.$route.params.deviceId
          this.items = (await DevicePanicService.show({deviceId})).data
          this.showProgress = false
        } catch (error) {
          this.showProgress = false
          this.errMsg = this.handleError(error)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceTabPanic.vue